/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "Ask anything about Closed Caption Creator" |
*
* @param {Assistant_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_empty_title = /** @type {((inputs?: Assistant_Empty_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Empty_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Posez toutes vos questions sur le créateur de sous-titres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fragen Sie alles über den Untertitel-Ersteller.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiedi qualsiasi cosa su Closed Caption Creator")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Задавайте любые вопросы о программе для создания субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pregunta lo que quieras sobre el Creador de Subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("询问有关隐藏式字幕创建器的任何问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Closed Caption Creatorについて何でも質問してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लोज्ड कैप्शन क्रिएटर के बारे में कुछ भी पूछें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pergunte qualquer coisa sobre o Criador de Legendas Ocultas.")
	return /** @type {LocalizedString} */ ("Ask anything about Closed Caption Creator")
});